import { render, staticRenderFns } from "./CargoList.vue?vue&type=template&id=56d18281&scoped=true"
import script from "./CargoList.vue?vue&type=script&lang=js"
export * from "./CargoList.vue?vue&type=script&lang=js"
import style0 from "./CargoList.vue?vue&type=style&index=0&id=56d18281&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d18281",
  null
  
)

export default component.exports